var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentFailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3969_10422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.2144 0 0 11.2144 0 25C0 38.7856 11.2144 50 25 50C38.7856 50 50 38.7856 50 25C50 11.2144 38.7856 0 25 0Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2062 31.2603C35.0207 32.0751 35.0207 33.3915 34.2062 34.2063C33.8 34.6126 33.2667 34.8167 32.733 34.8167C32.1997 34.8167 31.6664 34.6126 31.2601 34.2063L24.9998 27.9457L18.7395 34.2063C18.3333 34.6126 17.8 34.8167 17.2667 34.8167C16.733 34.8167 16.1997 34.6126 15.7934 34.2063C14.979 33.3915 14.979 32.0751 15.7934 31.2603L22.0541 25L15.7934 18.7397C14.979 17.9248 14.979 16.6084 15.7934 15.7936C16.6083 14.9791 17.9247 14.9791 18.7395 15.7936L24.9998 22.0542L31.2601 15.7936C32.075 14.9791 33.3914 14.9791 34.2062 15.7936C35.0207 16.6084 35.0207 17.9248 34.2062 18.7397L27.9455 25L34.2062 31.2603Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3969_10422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentFailed);
export default __webpack_public_path__ + "static/media/paymentFailed.1b475f636494fa47cfb49c8156c67811.svg";
export { ForwardRef as ReactComponent };